module.exports = __webpack_public_path__ + "assets/img/2.44eb6d18.png";